export default __webpack_public_path__ + "static/media/user-list.c861a3af.svg";